import { z } from 'zod';

import { GoogleAnalyticsEventsSchema } from '@nw/shared/config';
import { TemplateConfigDetailsSchema } from '@nw/shared/data-access';
import { validateJSONString } from '@nw/shared/utils';

import {
  MultiStepFormFieldsDataSchema,
  SegmentEventSchema
} from '../../shared/types/Schemas.zod';

export const DependentFormInfoSchema = z.object({
  dependent_form_id: z.string(),
  description: z.string(),
  navigation_button_text: z.string(),
  navigation_button_id: z.string()
});

export const FormConfigSchema = z.object({
  title: z.string(),
  instructions_text: z.string().optional(),
  submit_button_id: z.string().optional(),
  segment_events_types: z.record(SegmentEventSchema).optional(),
  should_send_segment_event: z.boolean().optional(),
  dependent_form_info: DependentFormInfoSchema.optional(),
  query_param_key: z.string().optional(),
  form_submission_type: z.string().optional(),
  google_analytics_events: GoogleAnalyticsEventsSchema.optional(),
  enable_postmessage: z.boolean().optional(),
  enable_otp_autofill: z.boolean().optional()
});

export const DefaultFormSchema = z.object({
  allowed_no_of_times_to_submit: z.number().nullable(),
  form_config: z.string().refine(validateJSONString(FormConfigSchema, false)),
  form_field_config: z
    .string()
    .refine(validateJSONString(MultiStepFormFieldsDataSchema, false)),
  form_info: z.string(),
  form_submission_message_config: z.string(),
  form_validation_config: z.string(),
  is_submission_edit_allowed: z.boolean(),
  on_submit_redirect_url: z.string(),
  template_config_details: z.array(TemplateConfigDetailsSchema).optional()
});
